import { Grid } from '@mui/material';
import ClientDetailForm from './ClientDetailForm';
import PrivacySettings from './PrivacySettings';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';
import { useAppSelector } from '../../redux/hooks';
import { ClientType } from '../../types/client';

function ClientDetail() {
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;
  const clientType = useAppSelector((state) => state.client.selectedClient?.clientType);
  const clientId = useAppSelector((state) => state.client.selectedClient?.id);
  return (
    <Grid container justifyContent="space-between" maxHeight="80vh" display="flex">
      {((clientType !== ClientType.GROUP &&
        checkPermissions(UserPermissionType.CORE_MODULE_VIEW_SINGLE_CLIENT)) ||
        (clientType === ClientType.GROUP &&
          checkPermissions(UserPermissionType.CLIENT_GROUP_MODULE_VIEW_CLIENT_GROUP))) && (
        <Grid
          item
          xs={12}
          md={7.8}
          xl={8.8}
          mt={2.5}
          boxShadow="0px 4px 40px 0px rgba(255, 181, 171, 0.20)"
          bgcolor="#FFF"
          borderRadius="10px"
        >
          <ClientDetailForm clientId={clientId || ''} />
        </Grid>
      )}
      {((clientType !== ClientType.GROUP &&
        checkPermissions(UserPermissionType.CORE_MODULE_VIEW_CLIENT_CONCENT)) ||
        (clientType === ClientType.GROUP &&
          checkPermissions(UserPermissionType.CLIENT_GROUP_MODULE_VIEW_CLIENT_GROUP))) && (
        <Grid item xs={8} md={4} xl={3} mt={2.5}>
          <PrivacySettings />
        </Grid>
      )}
    </Grid>
  );
}

export default ClientDetail;
